document.addEventListener("DOMContentLoaded", () => {
  document.body.addEventListener("click", (event) => {
    const button = event.target.closest(".load-more-button");
    if (!button) return;

    const sectionIds = button.dataset.sectionIds?.split(",").map(id => id.trim()).filter(Boolean);
    if (!sectionIds) return;

    for (const sectionId of sectionIds) {
      const el = document.getElementById(`shopify-section-${sectionId}`);
      if (el) {
        el.removeAttribute("data-lazy-hidden");
      } else {
        console.warn(`[ShowSections] ${sectionId} not found`);
      }
    }

    button.remove();
  });
});
